import { api } from '@/shared/api/client'

export const likeOfferQuery = async (wwtOfferId: string, setId: string) => {
	const response = await api()
		.url('/v1/offers/likes')
		.query({
			wwtOfferId,
			setId
		})
		.post()
		.json()

	return response
}
